import Image from "next/legacy/image";
import styled from "styled-components";
import { breakpoints } from "styles";
import { Chip } from "styles/common/chip";

export const SlotCardWrapper = styled.div<{
  isSelected: boolean;
  isDisabled: boolean;
}>`
  border: 2px solid
    ${({ isSelected, theme }) =>
      isSelected ? theme.colors.brand["500"] : theme.colors.neutral["200"]};
  border: ${({ isDisabled }) => (isDisabled ? "none" : "")};
  cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
  color: ${({ isDisabled, isSelected, theme }) =>
    isDisabled
      ? theme.colors.neutral["400"]
      : isSelected
        ? theme.colors.brand["500"]
        : theme.colors.brand["1000"]};
  background: ${({ isDisabled, isSelected, theme }) =>
    isDisabled
      ? theme.colors.neutral["100"]
      : isSelected
        ? theme.colors.blue["50"]
        : theme.colors.white};
  border-radius: 6px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s;

  &:hover {
    background: ${({ isDisabled, theme }) =>
      !isDisabled ? theme.colors.blue["50"] : ""};
  }
`;

export const SlotTitle = styled.p`
  font-weight: 700;
  font-family: ${({ theme }) => theme.fonts.primary};
  margin: 0;
`;

export const SlotScheduleWrapper = styled.div`
  min-width: 30%;
`;

export const SlotSchedule = styled.p`
  font-weight: 700;
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.md};
`;

export const StyledChip = styled(Chip)`
  display: block;
  width: fit-content;
  border: 0;
  font-family: ${({ theme }) => theme.fonts.secondary};
  padding: 2px 6px;
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes.xs};
  margin: 0;

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes.sm};
  }
`;

export const SlotStartDateAndSeatContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
  gap: 4px;
`;

export const ClashesText = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.neutral["700"]};
`;

export const ClashesWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const SlotInformationWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const TeacherDetailWrapper = styled.div`
  display: flex;
  border-left: 1px solid ${({ theme }) => theme.colors.neutral["200"]};
  margin-left: 16px;
  padding-left: 16px;
  align-items: center;
  gap: 12px;
`;

export const TeacherImage = styled(Image)`
  border-radius: 50%;
`;

export const TeacherName = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.neutral["1000"]};
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const RequiredClassWrapper = styled.div<{
  backgroundColor?: string;
}>`
  padding: 12px;
  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor || theme.colors.brand["100"]};
  margin: 0 16px;
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 6px;
  flex-grow: 0.8;
`;

export const RequiredClassText = styled.p<{
  color: string;
}>`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  line-height: 10px;
  color: ${({ color }) => color};
`;

export const DateClassText = styled.p<{
  color: string;
}>`
  color: ${({ theme, color }) => color || theme.colors.brand["500"]};
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  font-weight: 700;
  line-height: 20px;
  margin: 0;
`;
